<template>
  <v-row>
    <v-col
      cols="12"
      class="mb-2"
    >
      <v-text-field
        v-model="searchVal"
        label="Search"
        hide-details
        outlined
        clearable
        append-icon="mdi-magnify"
        @click:append="getAgents()"
        @keydown="checkKeypress"
      />
    </v-col>

    <v-col cols="12" style="position: relative;">
      
      <v-card>
        <v-btn
          absolute
          dark
          fab
          top
          right
          small
          color="primary"
          :to="{name: 'system-admin-agents-create'}"
        >
          <v-icon small>mdi-plus</v-icon>
        </v-btn>

        <v-data-table
          :headers="headers"
          :items="agents"
          :options.sync="options"
          :server-items-length="totalAgents"
          :loading="loading"
          :footer-props="tableFooterProps"
          @click:row="userClicked"
          @update:options="getAgents"
        >
          <template v-slot:[`item.full_name`]="{ item }">
            <div class="py-2">
              <v-tooltip top v-if="item.role == 'systemAdmin' || item.role == 'partnershipAdmin'">
                <template v-slot:activator="{on}">
                  <v-icon v-on="on" small class="mr-1">mdi-shield-account</v-icon>
                </template>
                <span v-text="(item.role == 'systemAdmin' ? 'System ' : '') + 'Admin'"></span>
              </v-tooltip>
              {{ item.full_name }}
              <br>
              <span class="grey--text">{{item.email}}</span>
            </div>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            {{ $moment.unix(item.created_at).calendar() }}
          </template>
          <template v-slot:[`item.partnership.name`]="{ item }">
            <div v-if="item.role == 'systemAdmin' || item.role == 'employee'">
              <v-row no-gutters class="align-center flex-nowrap">
                <v-col style="max-width: 90px; min-width: 90px; width: 90px;">
                  <v-img src="/images/logo.png" />
                </v-col>
              </v-row>
            </div>
            <div v-else>
              <span v-if="item.partnership">
                <v-icon x-small class="mr-1">mdi-handshake</v-icon>
                {{ item.partnership.name }}
              </span>
              <span v-else class="grey--text text--lighten-1">
                <v-icon x-small class="mr-1 grey--text text--lighten-1">mdi-handshake</v-icon>
                None
              </span>
            </div>
          </template>
          <template v-slot:[`item.subscription_status`]="{ item }">
            <div class="text-center">
              <div v-if="item.role != 'employee' && item.role != 'systemAdmin'">
                <span v-if="item.subscription_status == 'INACTIVE'">
                  <v-tooltip top>
                    <template v-slot:activator="{on}">
                      <v-icon v-on="on" class="error--text">mdi-do-not-disturb</v-icon>
                    </template>
                    <span>Inactive</span>
                  </v-tooltip>
                </span>
                <span v-else-if="item.subscription_status == 'ACTIVE'">
                  <v-tooltip top>
                    <template v-slot:activator="{on}">
                      <v-icon v-on="on" class="primary--text">mdi-circle</v-icon>
                    </template>
                    <span>Active</span>
                  </v-tooltip>
                </span>
              </div>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { TABLE_FOOTER_PROPS } from '@/global/consts';

export default {
  name: 'AdminAgentsIndex',
  data: () => ({
    loading: true,
    searchVal: null,
    agents: [],
    totalAgents: 0,
    options: {
      sortBy: ['created_at'],
      sortDesc: [true]
    },
    tableFooterProps: { ...TABLE_FOOTER_PROPS },
  }),
  computed: {
    headers () {
      const hd = [];

      hd.push({
        text: 'ID',
        align: 'start',
        value: 'id',
        width: '80px'
      })
      hd.push({
        text: 'Name',
        align: 'start',
        value: 'full_name',
      })
      if(this.$store.getters.userIs('employee')) {
        hd.push({
          text: 'Partnership',
          align: 'start',
          value: 'partnership.name'
        })
      }
      hd.push({
        text: 'Subscription',
        align: 'center',
        value: 'subscription_status',
        sortable: false,
        width: '120px'
      })
      hd.push({
        text: 'Created',
        align: 'start',
        value: 'created_at',
        width: '250px'
      })

      return hd;
    },
  },
  methods: {
    getAgents() {
      this.loading = true

      this.$http.get(`users?${this.getQueryParams()}`)
        .then(response => {
          this.agents = response.data.items;
          this.totalAgents = response.data._meta.totalCount;
        })
        .catch(err => {
          if (err.response.status == 401) return;
          this.$swal.fire('Error', 'There was an error loading agents', 'error')
        })
        .finally(() => this.loading = false);
    },
    getQueryParams() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      const { subscribers_ids } = this.$route.query;

      const qParams = [];
      qParams.push('expand=partnership,role');
      qParams.push('f[type]=AGENT');
      if(sortBy[0]) qParams.push('sort=' + (sortDesc[0] ? '-' : '') + sortBy[0]);
      qParams.push('per-page=' + itemsPerPage);
      qParams.push('page=' + page);
      if(this.searchVal) qParams.push('s=' + encodeURIComponent(this.searchVal));
      if(subscribers_ids?.length) qParams.push('f[id][in]=' + subscribers_ids);

      return qParams.join('&');
    },
    userClicked(agent) {
      this.$router.push({name: 'partnership-admin-agents-edit', params: { user_id: agent.id }})
    },
    checkKeypress(e) {
      if(e.key == 'Enter') this.getAgents()
    }
  }
}
</script>